<template lang="pug">
label
  p.flex.items-center
    span Choose languages: 

    span.relative.inline-flex.items-center.mx-4(class=" dark_bg-black/20 dark_text-gray-300 dark_ring-gray-600 dark_placeholder-gray-500 rounded-md bg-white text-gray-800 placeholder-gray-400 shadow-none ring-2 ring-gray-200 transition")
      .not-prose
      input.px-3.p-2.peer.font-monospace.font-normal.bg-transparent(class="[font-size:inherit] ![outline:none] ![box-shadow:none] [letter-spacing:2px] !bg-transparent !text-white !dark_text-black" type="text" v-model="value" placeholder="__ __ __")
      .absolute.inset-0.m-auto.pointer-events-none(class="rounded-md peer-focus_ring-4 peer-focus_ring-sky-400 dark_peer-focus_ring-sky-400 ")

      Popover.relative.absolute.right-0
        PopoverButton(type="button" ref="addButton").font-normal.text-xs.py-2.px-3.hover_bg-gray-900.hover_bg-opacity-50.mx-2.rounded.opacity-80 Add...
        PopoverPanel.font-normal.z-100.absolute.bg-gray-100.dark_bg-gray-800.p-2.rounded-md.shadow-md.dark_shadow-lg
          input.text-sm.rounded-sm.p-2.py-1.mb-2.focus_ring-2(type="text" class="!f" v-model="filterString" placeholder="Search..." ref="filterInput")

          .not-prose.simple-scrollbar(class="overflow-y-auto max-h-[20em]")
            ul
              li.hover_bg-primary-500.hover_bg-opacity-20(v-for="{code, english, name, deprecated} in filteredLanguages" :key="code" :class="{'bg-red-600/40': deprecated}") 
                PopoverButton.w-full.text-left.flex.items-center.gap-2(@click="value = (value.trimEnd() + ' ' + code).trim() + ' '") 
                  span.font-monospace.px-2(class="[w-5ch]") {{code}} 
                  span.opacity-80.text-xs {{ english }}
                  span.opacity-80.text-xs {{ deprecated ? '*deprecated' : '' }}

  //- select(:value="value" @input="value = $event.target.value")
  //-   option.font-monospace(value="" disabled) Select languages...
  //-   option.font-monospace(v-for="{code, english} in languages" :key="code" :value="code") {{code}} – {{ english }} 
</template>

<script setup lang="ts">
import { useEventListener, useVModel } from '@vueuse/core';
import languagesMap from '../../lib/languages.json';

import activeLanguages from '../../lib/activeLanguages.yml';
import { computed, ref } from 'vue';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';

// const activeLanguages = activeLanguagesString.trim().split(/\s+/);
declare module '../../lib/activeLanguages.yml' {
  const arr: string[];
  // @ts-ignore
  export default arr;
}

const props = defineProps<{
  modelValue: string;
  includeDeprecated?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);
const value = useVModel(props, 'modelValue', emit);

const addButton = ref<HTMLButtonElement | null>(null);
const filterInput = ref<HTMLInputElement | null>(null);
const filterString = ref('');

// active (include deprecated languages only if we have specified to)
const languages = Object.keys(languagesMap)
  .filter(
    code =>
      (activeLanguages.includes(code) && !languagesMap[code].deprecated) ||
      (props.includeDeprecated && languagesMap[code].deprecated)
  )
  .map(code => ({
    code,
    ...languagesMap[code]
  }));

const filteredLanguages = computed(() => {
  const alreadySelected = value.value.split(' ');
  return languages.filter(({ code, english, name }) => {
    const f = filterString.value.toLowerCase();
    return (
      !alreadySelected.includes(code) &&
      (code.toLowerCase().includes(f) ||
        english.toLowerCase().includes(f) ||
        name.toLowerCase().includes(f))
    );
  });
});

useEventListener(addButton, 'click', () => {
  filterInput.value?.focus();
});
</script>

<style scoped>
.animate-bounce {
  animation: bounce 1s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateX(0);
  }
  40% {
    transform: translateX(-10px);
  }
  60% {
    transform: translateX(-5px);
  }
}
</style>
